module.exports = __webpack_public_path__ + "static/media/swordblack.26d0e420.png";